/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoachClass } from '../models/CoachClass';
import type { CreateCoachClassDto } from '../models/CreateCoachClassDto';
import type { UpdateCoachClassDto } from '../models/UpdateCoachClassDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CoachClassService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns CoachClass
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody: CreateCoachClassDto,
  }): CancelablePromise<CoachClass> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/coach-class',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any[]
   * @throws ApiError
   */
  public find(): CancelablePromise<any[]> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/coach-class',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public updateById({
    id,
    requestBody,
    relations,
  }: {
    id: number,
    requestBody: UpdateCoachClassDto,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/v1/coach-class/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public deleteById({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/coach-class/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
}
